import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  moreTo,
  moreLabel = "查看全部",
  children,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div className="max-w-2xl">
        {eyebrow && (
          <div className="flex items-center gap-2 mb-3">
            <span className="w-6 h-[3px] rounded-full bg-accent-500"></span>
            <span className="text-xs font-label font-medium tracking-[0.2em] text-accent-700 uppercase">
              {eyebrow}
            </span>
          </div>
        )}
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">{title}</h2>
        {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
      </div>
      {children}
      {moreTo && (
        <Link
          to={moreTo}
          className="self-start md:self-auto inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer group"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      )}
    </div>
  );
}